var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-spinner-wrapper",class:{'small': _vm.small, 'very-small': _vm.verySmall}},[_c('b-spinner',{staticClass:"app-spinner",attrs:{"type":"grow","label":"Spinning"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }